<template>
  <div class="number-info-body">
    <div class="number-info-content write-info-content">
      <div class="success-icon-box">
        <img src="@/assets/img/cjsh.png" />
        <p>提交信息成功！</p>
      </div>
      <div class="enterprise-info">
        <div>
          <div style="width: 100%">
            <span>
              {{
                company && company.companyType === "1"
                  ? "政府组织名称"
                  : "企业组织名称"
              }}
            </span>
            <p>{{ company.companyName }}</p>
          </div>
          <div style="width: 100%" v-if="company.socialCreditCode">
            <span>统一社会信用代码</span>
            <p>{{ company.socialCreditCode }}</p>
          </div>
          <div style="width: 100%" v-if="company.socialCreditCodeExplain">
            <span>无社会信用代码说明</span>
            <p>{{ company.socialCreditCodeExplain }}</p>
          </div>
          <div>
            <span>联系人</span>
            <p>{{ company.contactPerson }}</p>
          </div>
          <div>
            <span>联系方式</span>
            <p>{{ company.contactPhone }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="success-footer">
      <a-button @click="home">返回平台首页</a-button>
      <a-button @click="login">登录用户中心</a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["userInfo"]),
    company() {
      return (this.userInfo && this.userInfo.company) || {};
    },
  },
  methods: {
    home() {
      this.$router.push("/homeIndex");
    },
    login() {
      this.$router.push("/after");
    },
  },
};
</script>

<style lang="less" scoped>
.number-info-body {
  height: 100%;
  width: 640px;
  margin: 0 auto;
  padding: 40px 0;

  .number-info-content {
    height: 510px;
    padding-top: 40px;

    .success-icon-box {
      margin-bottom: 40px;

      > img {
        display: block;
        margin: 0 auto 40px;
      }

      > p {
        font-size: 16px;
        text-align: center;
        line-height: 16px;
      }
    }

    .enterprise-info {
      padding-left: 34px;
      margin-bottom: 24px;

      > div {
        display: flex;
        flex-wrap: wrap;
        border-top: 1px solid #f0f0f0;
        border-left: 1px solid #f0f0f0;

        > div {
          width: 50%;
          display: flex;

          > span {
            width: 120px;
            line-height: 32px;
            background: #ebf9f6;
            border-right: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            padding-left: 10px;
            color: #8c8c8c;
            font-size: 12px;
          }

          > p {
            flex: 1;
            padding: 0 10px;
            border-right: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            font-size: 12px;
            height: 32px;
            line-height: 32px;
          }
        }
      }
    }
  }

  .success-footer {
    display: flex;
    justify-content: space-between;

    > button {
      width: 308px;
      height: 48px;
      background: #ffffff;
      border: 1px solid #1abc9c;
      border-radius: 2px;
      font-size: 16px;
      color: #1abc9c;
    }
  }
}
</style>
